import { CloseIcon } from "../../utils/icon.utils";
import Button from "../../ui/Button";

export default function RemoveAdditionalCost({ control, errors, setValue, others, unregister }) {
  const { count, setFields } = others;
  function handleRemove() {
    setFields((prev) => {
      const prevField = [...prev];
      return prevField.filter((item) => item.index !== count);
    });
    unregister(`car.additionalCost.${count}.name`);
    unregister(`car.additionalCost.${count}.cost`);
    unregister(`car.additionalCost.${count}.remarks`);
  }

  return (
    <>
      <div style={{ height: 35 }}></div>
      <Button color="danger" onClick={handleRemove} name="Remove" icon={CloseIcon} />
    </>
  );
}
